import { faker } from '@faker-js/faker';

// Arrays com dados brasileiros
const NOMES_BRASILEIROS = [
  'João Silva', 'Maria Santos', 'José Oliveira', 'Ana Costa', 'Carlos Souza',
  'Fernanda Lima', 'Roberto Ferreira', 'Juliana Alves', 'Pedro Rodrigues', 'Camila Pereira',
  'Marcelo Carvalho', 'Priscila Barbosa', 'Rafael Gomes', 'Tatiana Martins', 'Gustavo Ribeiro',
  'Luciana Araújo', 'Eduardo Cardoso', 'Vanessa Nascimento', 'Thiago Moreira', 'Patrícia Dias'
];

const CIDADES_BRASILEIRAS = [
  'São Paulo', 'Rio de Janeiro', 'Belo Horizonte', 'Salvador', 'Brasília',
  'Fortaleza', 'Curitiba', 'Recife', 'Porto Alegre', 'Goiânia',
  'Belém', 'Guarulhos', 'Campinas', 'São Luís', 'São Gonçalo',
  'Maceió', 'Duque de Caxias', 'Campo Grande', 'Natal', 'Teresina'
];

const ESTADOS_BRASILEIROS = [
  'SP', 'RJ', 'MG', 'BA', 'DF', 'CE', 'PR', 'PE', 'RS', 'GO',
  'PA', 'SC', 'PB', 'ES', 'PI', 'AL', 'RN', 'MT', 'MS', 'SE'
];

// Hook para gerar dados fictícios
export const useFakeData = () => {
  
  // Função para gerar CPF válido (formato com máscara)
  const gerarCPF = () => {
    // Gera 9 dígitos aleatórios
    const digits = Array.from({ length: 9 }, () => faker.number.int({ min: 0, max: 9 }));
    
    // Calcula primeiro dígito verificador
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += digits[i] * (10 - i);
    }
    const firstDigit = ((sum * 10) % 11) % 10;
    
    // Calcula segundo dígito verificador
    sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += digits[i] * (11 - i);
    }
    sum += firstDigit * 2;
    const secondDigit = ((sum * 10) % 11) % 10;
    
    // Formata CPF com máscara
    const cpfArray = [...digits, firstDigit, secondDigit];
    return `${cpfArray.slice(0,3).join('')}.${cpfArray.slice(3,6).join('')}.${cpfArray.slice(6,9).join('')}-${cpfArray.slice(9).join('')}`;
  };

  // Função para gerar telefone brasileiro
  const gerarTelefone = () => {
    const ddd = faker.helpers.arrayElement(['11', '21', '31', '41', '51', '61', '71', '81', '85', '27']);
    const numero = faker.helpers.fromRegExp(/9[0-9]{4}-[0-9]{4}/);
    return `(${ddd}) ${numero}`;
  };

  // Função para gerar telefone fixo brasileiro
  const gerarTelefoneFixo = () => {
    const ddd = faker.helpers.arrayElement(['11', '21', '31', '41', '51', '61', '71', '81', '85', '27']);
    const numero = faker.helpers.fromRegExp(/[2-5][0-9]{3}-[0-9]{4}/);
    return `(${ddd}) ${numero}`;
  };

  // Função para gerar RG brasileiro
  const gerarRG = () => {
    const digits = Array.from({ length: 8 }, () => faker.number.int({ min: 0, max: 9 }));
    return `${digits.slice(0,2).join('')}.${digits.slice(2,5).join('')}.${digits.slice(5,8).join('')}-${faker.number.int({ min: 0, max: 9 })}`;
  };

  // Função para gerar CEP brasileiro
  const gerarCEP = () => {
    const cep = Array.from({ length: 8 }, () => faker.number.int({ min: 0, max: 9 }));
    return `${cep.slice(0,5).join('')}-${cep.slice(5).join('')}`;
  };

  // Gerar dados completos para colaborador
  const gerarDadosColaborador = () => {
    const isEstrangeira = faker.datatype.boolean(0.1); // 10% chance de ser estrangeiro
    const nomeCompleto = faker.helpers.arrayElement(NOMES_BRASILEIROS);
    const [firstName, ...lastNameParts] = nomeCompleto.split(' ');
    const lastName = lastNameParts.join(' ');
    
    return {
      // Dados pessoais básicos
      nome: nomeCompleto,
      email: faker.internet.email({ firstName, lastName }).toLowerCase(),
      cpf: isEstrangeira ? '' : gerarCPF(),
      docEstrangeiro: isEstrangeira ? `${faker.helpers.arrayElement(['V', 'VITEM', 'VIVIS', 'RNE'])}${faker.number.int({ min: 100000, max: 999999 })}` : '',
      estrangeira: isEstrangeira,
      dataNascimento: faker.date.birthdate({ 
        min: 18, 
        max: 70, 
        mode: 'age' 
      }).toISOString().split('T')[0],
      
      // Documentos
      identidade: gerarRG(),
      orgaoExpedidor: faker.helpers.arrayElement(['SSP', 'DETRAN', 'PF', 'PM']),
      estadoCivil: faker.helpers.arrayElement(['Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viúvo(a)']),
      
      // Contatos
      telefoneCelular: gerarTelefone(),
      telefoneResidencial: faker.datatype.boolean(0.3) ? gerarTelefoneFixo() : '',
      telefoneComercial: faker.datatype.boolean(0.2) ? gerarTelefoneFixo() : '',
      
      // Endereço
      logradouro: faker.location.streetAddress(),
      numero: faker.number.int({ min: 1, max: 9999 }).toString(),
      complemento: faker.datatype.boolean(0.3) ? faker.helpers.arrayElement(['Apto 101', 'Casa 2', 'Bloco A', 'Fundos']) : '',
      bairro: faker.helpers.arrayElement(['Centro', 'Vila Nova', 'Jardim América', 'São José', 'Copacabana']),
      cidade: faker.helpers.arrayElement(CIDADES_BRASILEIRAS),
      estado: faker.helpers.arrayElement(ESTADOS_BRASILEIROS),
      cep: gerarCEP(),
      pais: isEstrangeira ? faker.location.country() : 'Brasil',
      
      // Dados da igreja
      nomeIgrejaCongrega: `AD ${faker.helpers.arrayElement(CIDADES_BRASILEIRAS)}`,
      nomePastor: `Pr. ${faker.helpers.arrayElement(NOMES_BRASILEIROS)}`,
      logradouroIgreja: faker.location.streetAddress(),
      numeroIgreja: faker.number.int({ min: 1, max: 999 }).toString(),
      bairroIgreja: faker.helpers.arrayElement(['Centro', 'Vila Nova', 'Jardim América']),
      cidadeIgreja: faker.helpers.arrayElement(CIDADES_BRASILEIRAS),
      estadoIgreja: faker.helpers.arrayElement(ESTADOS_BRASILEIROS),
      cepIgreja: gerarCEP(),
      paisIgreja: 'Brasil',
      telefoneIgreja: gerarTelefoneFixo(),
      
      // Dados profissionais/ministeriais
      cargo: faker.helpers.arrayElement([
        'Pastor(a)',
        'Missionário(a)', 
        'Evangelista',
        'Presbítero',
        'Diácono(nisa)',
        'Aux. de Trabalho',
        'Membro',
        'Líder de Dpto',
        'Congregado'
      ]),
      funcao: faker.helpers.arrayElement([
        'Coordenador(a)',
        'Professor(a)',
        'Secretário(a)'
      ]),
      status: faker.helpers.arrayElement(['Ativo', 'Inativo'], [0.9, 0.1]), // 90% ativo
      
      // Formação
      escolaridade: faker.helpers.arrayElement([
        'Fundamental Incompleto',
        'Fundamental Completo', 
        'Médio Incompleto',
        'Médio Completo',
        'Superior Incompleto',
        'Superior Completo',
        'Pós-graduação',
        'Mestrado',
        'Doutorado'
      ]),
      
      // Documentos (checkboxes)
      docComprovanteResidencia: faker.datatype.boolean(0.8),
      docCpf: faker.datatype.boolean(0.9),
      docHistoricoEscolar: faker.datatype.boolean(0.6),
      docIdentidade: faker.datatype.boolean(0.9),
      docCertidaoCasamentoNascimento: faker.datatype.boolean(0.7),
      docFoto: faker.datatype.boolean(0.8)
    };
  };

  // Gerar dados específicos para aluno
  const gerarDadosAluno = () => {
    const dadosBase = gerarDadosColaborador();
    return {
      ...dadosBase,
      matricula: faker.helpers.fromRegExp(/^\d{4}-\d{4}$/),
      dataMatricula: faker.date.recent({ days: 365 }).toISOString().split('T')[0],
      tipoCurso: faker.helpers.arrayElement([
        'Teologia',
        'Educação Cristã', 
        'Música Sacra',
        'Missões',
        'Aconselhamento'
      ]),
      periodo: faker.helpers.arrayElement(['Matutino', 'Vespertino', 'Noturno'])
    };
  };

  // Gerar dados mínimos (apenas campos obrigatórios)
  const gerarDadosMinimos = () => {
    const nomeCompleto = faker.helpers.arrayElement(NOMES_BRASILEIROS);
    const [firstName, ...lastNameParts] = nomeCompleto.split(' ');
    const lastName = lastNameParts.join(' ');
    
    return {
      nome: nomeCompleto,
      email: faker.internet.email({ firstName, lastName }).toLowerCase(),
      cpf: gerarCPF(),
      telefoneCelular: gerarTelefone()
    };
  };

  // Gerar dados para teste de validação (dados inválidos)
  const gerarDadosInvalidos = () => {
    return {
      nome: '', // nome vazio para testar validação
      email: 'email-invalido', // email inválido
      cpf: '123.456.789-00', // CPF inválido
      telefoneCelular: '123', // telefone inválido
      dataNascimento: '2030-01-01' // data futura
    };
  };

  return {
    gerarDadosColaborador,
    gerarDadosAluno,
    gerarDadosMinimos,
    gerarDadosInvalidos,
    gerarCPF,
    gerarRG,
    gerarTelefone,
    gerarTelefoneFixo,
    gerarCEP
  };
};

export default useFakeData;
